import { IToken } from "@/store/types/user-types";
import { General } from "@/utils/constants";
import { ICC } from "@/store/types/process-type";

export const parseJwt = (token: IToken) => {
  if (!token) return "";
  const base64Url = token.split(".")[1];
  if (!base64Url) return {};
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};

export const formatPagination = (
  dataObject: { count: number },
  page: number,
  perPage: number,
  isDetailed: `DETAILED` | `SIMPLIFIED` = "DETAILED"
) => {
  const count = dataObject.count;
  const listStartingNumber = count ? (page - 1) * perPage + 1 || 1 : 0;
  const listEndingNumber = count > perPage * page ? perPage * page : count;

  return isDetailed == `DETAILED`
    ? `${listStartingNumber} - ${listEndingNumber} ${General.FROM.toLowerCase()} ${count} ${General.RECORD_PLURAL.toLowerCase()}`
    : `${listEndingNumber} ${General.FROM.toLowerCase()} ${count} ${General.RECORD_PLURAL.toLowerCase()}`;
};

export const getCCFormated = (cc: ICC) => {
  if (cc.user_cpf) return cc.user_cpf;
  if (!cc.abbreviation || !cc.entity) return "";
  const abbreviation = cc.abbreviation.includes("/")
    ? cc.abbreviation.split("/")[1]
    : cc.abbreviation;
  return `${cc.entity.abbreviation}/${abbreviation}`;
};
